module.exports = __webpack_public_path__ + "static/media/prizm-MX.97ffb66c.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/screens/prizm/prizm-MX.mp4
// module id = 3533
// module chunks = 0